module.exports = __webpack_public_path__ + "img/kv_sp.33982f9b.jpg";